"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("react");
const viewAllApprovalsToggle_1 = __importDefault(require("../../../pages/activity/activityHeaderActions/viewAllApprovalsToggle"));
const headerNavigationTab_1 = __importDefault(require("./headerNavigationTab"));
require("./index.less");
const activityPaths = ['/activity', '/activity/approved', '/activity/declined', '/activity/canceled'];
const HeaderNavigation = ({ tabs = [], end = true }) => {
    const isActivityPage = activityPaths.includes(globalThis.location.pathname);
    return ((0, jsx_runtime_1.jsx)("nav", { className: "navigation", children: (0, jsx_runtime_1.jsx)("div", { className: "navigation-menu", children: (0, jsx_runtime_1.jsxs)("ul", { "data-testid": "header-navigation-menu", children: [tabs.map(tab => ((0, react_1.createElement)(headerNavigationTab_1.default, { ...tab, key: tab.label, end: end }))), (0, jsx_runtime_1.jsx)(react_2.Suspense, { fallback: null, children: isActivityPage ? ((0, jsx_runtime_1.jsx)("li", { className: "tab-link", style: { marginLeft: 'auto', marginRight: '-12px' }, children: (0, jsx_runtime_1.jsx)(viewAllApprovalsToggle_1.default, {}) })) : null })] }) }) }));
};
exports.default = HeaderNavigation;
